document.addEventListener('DOMContentLoaded', function () {
    var allElements = document.querySelectorAll('*');
    allElements.forEach(function (el) {
        var childNodes = Array.from(el.childNodes);
        childNodes.forEach(function (node) {
            if (node.nodeType === Node.COMMENT_NODE) {
                el.removeChild(node);
            }
        });
    });
});